import React from 'react';

import styled from 'styled-components';

import { StyledTable } from 'common/Table/StyledTable';

import AiCiTableWrapper, { AiCiSection, AiCiSectionTitle } from './AiCiTableWrapper';

export type Criterion = {
  key?: string;
  label?: string;
  score?: number | null;
  explanation?: string | null;
  description?: string;
};

const CriterionLabel = styled.div`
  font-family: var(--font-bold);
`;

const MutedText = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.5;
`;

const listColumns = [
  {
    title: 'CRITERION',
    dataIndex: 'label',
    key: 'label',
    width: 280,
    render: (_: unknown, c: Criterion) => <CriterionLabel>{c.label ?? c.key ?? '—'}</CriterionLabel>,
  },
  {
    title: 'DESCRIPTION',
    dataIndex: 'description',
    key: 'description',
    render: (description: string | undefined) => <MutedText>{description ?? ''}</MutedText>,
  },
];

const breakdownColumns = [
  {
    title: 'CRITERIA',
    dataIndex: 'label',
    key: 'label',
    width: 240,
    render: (_: unknown, c: Criterion) => <CriterionLabel>{c.label ?? c.key ?? '—'}</CriterionLabel>,
  },
  {
    title: 'SCORE',
    dataIndex: 'score',
    key: 'score',
    width: 100,
    align: 'center' as const,
    render: (score: number | null | undefined) => (typeof score === 'number' ? score : <MutedText>—</MutedText>),
  },
  {
    title: 'EXPLANATION',
    dataIndex: 'explanation',
    key: 'explanation',
    render: (explanation: string | null | undefined) => (explanation ? <MutedText>{explanation}</MutedText> : null),
  },
];

type Props = {
  title: string;
  criteria: Criterion[];
  variant: 'list' | 'breakdown';
};

const AiCiCategoryCriteriaTable = ({ title, criteria, variant }: Props) => (
  <AiCiSection>
    <AiCiSectionTitle>{title}</AiCiSectionTitle>
    <AiCiTableWrapper>
      <StyledTable
        columns={(variant === 'list' ? listColumns : breakdownColumns) as any}
        dataSource={criteria}
        rowKey={((c: Criterion, i: number) => c.key ?? String(i)) as any}
        pagination={false}
        size="middle"
        bordered={false}
      />
    </AiCiTableWrapper>
  </AiCiSection>
);

export default AiCiCategoryCriteriaTable;
